<template lang="pug">
  .giftcard-design-swatches
    Swatches.design(
      v-if="designOpts.length"
      label="Card Design"
      :required="true"
      v-model="giftcardConfig.design"
      @update:modelValue="onValueChanged"
      :options="designOpts"
      :customWidth="270"
      :customHeight="270"
    )
    img#preload(:src="preloadImage" alt="")
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { DESIGN_URLS } from './giftcard-designs'
import type { BuyRequest, GiftcardMetadata } from '@/js/services/types/order'

const props = defineProps<{
  buyRequest: BuyRequest
}>()

const designOpts = DESIGN_URLS
const preloadImage = ref<string | null>(null)

// Only rendered for a giftcard buy request, which always carries this metadata.
const giftcardConfig = computed(() => props.buyRequest.metadata?.giftcard as GiftcardMetadata)

watch(() => props.buyRequest.metadata?.giftcard, (giftcard) => {
  const amount = `${giftcard?.customAmount || giftcard?.amount}`.replace(',', '%252C')
  preloadImage.value = `https://assets.roguefitness.com/co_rgb:fff,g_south_east,l_text:Roboto%20Condensed_110_bold:$${amount}.00,x_40,y_40${giftcard?.design}`
}, { deep: true })

giftcardConfig.value.design = designOpts[0].value
giftcardConfig.value.thumbnail = designOpts[0].image

function onValueChanged(value: string) {
  const design = designOpts.find(designUrl => designUrl.value === value)
  if (design) {
    giftcardConfig.value.thumbnail = design.image
  }
}
</script>

<style lang="scss" scoped>
.design {
  margin-bottom: $space-s;
}
</style>

<style lang="scss">
.giftcard-design-swatches {
  width: 100%
}
#preload {
  display: none;
}
.design.swatches-fixed .swatches .swatch-holder {
  height: 96px;
  width: 96px;
}

.design .swatches .swatch-holder .swatch {
  padding: 0;
}

.design .swatch-holder .swatch .swatch-border {
  border: 1px solid #f8f8f8;
}
</style>
